import { useSetAtom } from 'jotai';
import React, { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useWidgetState, useRestaurant, UserAtom } from '../lib/state.ts';
import { sanitizeReferralCode } from '../lib/sanitizeReferralCode.ts';
import EventPage from './EventPage.tsx';
import 'react-phone-number-input/style.css';

const Booking: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [, updateWidget] = useWidgetState();
  const { restaurant, meta } = useRestaurant();
  const code = sanitizeReferralCode(searchParams.get('code'));
  const setUser = useSetAtom(UserAtom);
  const appliedReferralCodeRef = useRef<string | null>(null);

  useEffect(() => {
    if (!code || appliedReferralCodeRef.current === code) {
      return;
    }
    appliedReferralCodeRef.current = code;

    setUser({
      referral_code: code,
    });

    updateWidget({
      referral_code: code,
    });
  }, [code, setUser, updateWidget]);

  // All restaurants use the unified EventPage UI
  return <EventPage restaurant={restaurant} meta={meta} />;
};

export default Booking;
